<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Duas Assinaturas Ativas em um CPF"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getTwoSubscriptionsInOneCpfTable"
  emptyMessage="Sem mais duas assinaturas ativas vinculadas ao mesmo CPF no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="updateStatus($event)"
  modelName="Registros"
  [defaultRows]="15"
  *ngIf="dropdownFilters"
  [dropdownFilters]="dropdownFilters"
  [multiSelectFilter]="true"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
